import Image from 'next/image'
import { CarouselContainer } from '@Components/carousel'
import { CarouselItem } from '@Components/ui/carousel'
import { chunkArray } from '../../../utils/chunkArray'
import QouteOpen from '../../../../public/images/qoute-open.svg'
import QouteEnd from '../../../../public/images/qoute-end.svg'
import StarEmpty from '../../../../public/images/star-empty.svg'
import StarFull from '../../../../public/images/star-full.svg'
import { TestimonialResponse } from '../../../apis/landingPages'
import LayoutWithSpacing from '@Components/layout/layoutWithSpacing'
import { useScreenSize } from '../../../hooks/useScreenSize'
import { useEffect, useState } from 'react'

const Testimonial = ({ data }: { data: TestimonialResponse }) => {
  const [basis, setBasis] = useState('basis-1/2')
  const [chunkedData, setChunkedData] = useState<any[]>([])
  const [pageCount, setPageCount] = useState(0)
  const { isMobile } = useScreenSize()

  useEffect(() => {
    const separateData = isMobile ? 1 : 2
    const pageCount = Math.ceil(data?.Contents.length / separateData)
    const chunkedData = chunkArray(
      data?.Contents,
      separateData
    ) as TestimonialResponse[]
    if (isMobile) {
      setBasis('basis-full')
    } else {
      setBasis('basis-1/2')
    }
    setChunkedData(chunkedData)
    setPageCount(pageCount)
  }, [isMobile])

  return (
    <div className='w-full bg-content-default'>
      <LayoutWithSpacing className='flex flex-col gap-y-8'>
        <div className='text-[1.563rem] font-bold text-content-on-color-background'>
          {data.Title}
        </div>
        <CarouselContainer
          pageCount={chunkedData.length}
          dataLength={pageCount}
          variant='inverse'
          customClass='flex flex-col gap-8'
        >
          {Array.from({ length: pageCount }).map((_, index) => (
            <CarouselItem
              key={index}
              className='flex flex-row justify-between gap-8'
            >
              {chunkedData[index]?.map((item: any, index: number) => (
                <div
                  key={`${item.id}-${index}`}
                  className={`flex w-full flex-col gap-8 rounded-2xl bg-neutral-level-1-default p-6 pb-8 text-content-default ${basis}`}
                >
                  <div className='flex h-20 flex-row gap-6'>
                    <div className='relative h-20 w-20'>
                      <Image
                        className='absolute'
                        src={item.Image?.url}
                        alt=''
                        width={100}
                        height={100}
                      />
                      <div className='flex h-full w-full items-end justify-end'>
                        <div className='absolute flex h-10 w-10 rounded-[6.25rem] bg-neutral-level-1-default p-1'>
                          <Image
                            className='flex  rounded-[6.25rem]'
                            src={item.Logo?.url}
                            alt=''
                            width={100}
                            height={100}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='flex flex-col justify-center gap-2'>
                      <div className='font-bold'>{item.Fullname}</div>
                      <div>{item.Department}</div>
                    </div>
                  </div>
                  <div className='flex flex-col gap-3'>
                    <div className='relative flex flex-row justify-between'>
                      <div className='flex items-start'>
                        <Image src={QouteOpen} alt='' />
                      </div>
                      <div className='flex flex-col justify-center gap-3'>
                        <div className='flex flex-row justify-center gap-1'>
                          {Array.from({ length: 5 }).map((_, index) => (
                            <Image
                              key={index}
                              src={index < item.Point ? StarFull : StarEmpty}
                              alt=''
                            />
                          ))}
                        </div>
                        <div className='text-center text-[1.563rem]'>
                          <div className='font-bold'>{item.Header}</div>
                          <div>{item.Content}</div>
                        </div>
                      </div>
                      <div className='flex items-end'>
                        <Image src={QouteEnd} alt='' />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </CarouselItem>
          ))}
        </CarouselContainer>
      </LayoutWithSpacing>
    </div>
  )
}

export default Testimonial
